import ActionType from '../actions/ActionType'

export default (state = {
  contactID: null,
  toValue: null,
  body: '',
  initialBody: ''
}, action) => {
  switch (action.type) {
    case ActionType.SMS.CLICK_CONTACT_TO_TEXT:
      return {
        ...state,
        contactID: action.payload && action.payload.id ? action.payload.id : null,
        toValue: action.payload && action.payload.id ?
          {
            contactID: action.payload.id,
            value: action.payload.email,
            label: `${action.payload.first_name} ${action.payload.last_name}`
          } :
          { }
      }
    case ActionType.SMS.HANDLE_TO_CHANGE:
      return {
        ...state,
        toValue: action.payload.newValue,
      }
    case ActionType.SMS.HANDLE_BODY_CHANGE:
      return {
        ...state,
        body: action.payload,
      }
    case '@@router/LOCATION_CHANGE':
      if (action.payload.location.search.slice(0,7) !== '?taskID') {
        return { ...state, body: '', initialBody: '' }
      }
      return state
    case ActionType.Tasks.RECEIVE_TASK:
      if (action.payload && action.payload.task_type_id === '2') {
        return {
          ...state,
          body: action.payload.send_sms.trigger_data.body,
          initialBody: action.payload.send_sms.trigger_data.body,
        }
      }
      return state
    default:
      return state
  }
}
